
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 5h2v2h8.469l.281.344 3.563 4.156-3.563 4.156-.281.344H5V7h10V5zM7 9v5h17.531l2.156-2.5L24.531 9H7zm8 8h2v10h-2V17z"}})])
          )
        }
      }
    